// extracted by mini-css-extract-plugin
module.exports = {"chipContainer":"Hero_chipContainer__Euw3e","singleChipContainer":"Hero_singleChipContainer__ISRMY"};